import React from 'react'
import { useRef } from 'react'
import { motion } from 'framer-motion'
import { Grid } from '@mui/material'
import styled from 'styled-components'
import CardGlobal from '../../../share/components/cardGlobal'
import Paginado from '../../../../../Routes/Home/Paginado'
import Paquetes from '../../../../viewModels/packages/Paquetes'
import './styles.css'

const ListCardsTours = () => {


    const MotionConstraints = styled(motion.div)`
    overflow-x: hidden;
  `;

    const MotionBox = styled(motion.div)`
    width: 400vw;
  `

    const constraintsRef = useRef(null)

    const {
        paquetes,
        nextHandler,
        prevHandler,
        services,
        topic,
        currentPage,
        mostrarNext,
    } = Paquetes()



    return (
        <div>
            <div className='contain-title-list-home'>
                <h2>
                    Paquetes Wellezy
                </h2>
                <p>
                    Viaja con Wellezy paquetes todo incluido para ti
                </p>
            </div>
            <section className='contain-packages-all'>
                <div className='layout-packages'>
                    {
                        topic.map((item) => {
                            return (
                                <CardGlobal key={item.id} data={item} />
                            )
                        })
                    }
                </div>


                <div className='contain-carousel-p'>

                    <MotionConstraints className='slider_container' ref={constraintsRef}>
                        <MotionBox className='slider_' drag='x' dragConstraints={constraintsRef}  >
                            {
                                paquetes.map((item) => {
                                    return (
                                        <motion.div className='div_homeTurism' key={item.id}>
                                            <Grid item xs={6} sm={6} md={3} lg={2} className='grid_cardHomeTurism'>
                                                <CardGlobal key={item.id} data={item} />
                                            </Grid>
                                        </motion.div>
                                    )
                                })
                            }

                        </MotionBox>
                    </MotionConstraints>
                </div>
                <div className='contain-paginado'>

                    <Paginado

                        nextHandler={nextHandler}
                        prevHandler={prevHandler}
                        currentPage={currentPage}
                        mostrarNext={mostrarNext}
                        totalItems={services.length}
                    >

                    </Paginado>
                </div>
            </section>
        </div>
    )
}

export default ListCardsTours